module.exports = __webpack_public_path__ + "resources/images/medischebehandeling-5b99f9854b45db29b16e9bc59f1e479a-cache.jpg";